import useGetPublicBookDetails, { QmsPublicBookDetails } from './useGetPublicBookDetails';

export default useGetPublicBookDetails;
export type { QmsPublicBookDetails };
